export default "<app-rest-password-layout [operation]=\"resetPasswordConstantes.operations.refresh_mdp\"></app-rest-password-layout>\r\n";